<div class="row">
  <div class="col-12">
      <div class="card">
          <div class="card-body">
              <!-- table start -->
              <app-advanced-table *ngIf="loaded" [tableData]="records" [columns]="columns" [pagination]="true"
                  [pageSizeOptions]="pageSizeOptions" [hasRowSelection]="true" [isSearchable]="true"
                  (search)="searchData($event)" [isSortable]="true" (sort)="onSort($event)" [buttonLink]="buttonLink"
                  [buttonTitle]="buttonTitle" [disableNoAdmin]="false" (deleteClick)="openDeleteModal($event)">
              </app-advanced-table>

              <div id="status" *ngIf="!loaded && !error">
                  <div class="spinner">
                      <div></div>
                      <div></div>
                      <div></div>
                  </div>
              </div>

              <ngb-alert [dismissible]="false" type="danger" *ngIf="error">
                  {{ error }}
              </ngb-alert>
          </div> <!-- end card body-->
      </div> <!-- end card -->
  </div><!-- end col-->
</div>
<!-- end row-->

<!-- Modal para confirmar borrado -->
<div class="confirm-delete-modal" *ngIf="showConfirmDeleteModal">
    <div class="confirm-delete-modal-content">
      <div class="confirm-delete-modal-header">
        <h5 class="confirm-delete-modal-title" i18n>Confirmar Borrado</h5>
      </div>
      <div class="confirm-delete-modal-body">
        <p><span i18n>¿Estás seguro de que deseas borrar la plantilla</span> {{ plantillaToDelete?.nombre }}?</p>
      </div>
      <div class="confirm-delete-modal-footer">
        <button type="button" class="btn btn-danger waves-effect waves-light" style="margin-right: 20px;"
          (click)="confirmDelete()">
          <span class="btn-label"><i class="fe-trash"></i></span><span i18n>Borrar</span>
        </button>
        <button type="button" class="btn btn-secondary waves-effect waves-light" (click)="closeDeleteModal()">
          <span class="btn-label"><i class="fe-x"></i></span><span i18n>Cancelar</span>
        </button>
      </div>
    </div>
  </div>